import type { Enums } from "../types";

export const serviceUnits = [
	"piece",
	"piece-week",
	"meters",
	"meters-week",
	"square-meters",
	"square-meters-week",
	"cubic-meters",
] as const satisfies readonly Enums<"unit">[];
